import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { encryptedRequest } from "../core/api.client";

type IOTPVRetryAPIResponse = {
  podRequestId: string;
  currentStage: string;
  nextStage: string;
  lastStageData: null | string;
  currentStageData: string;
  customerType: string;
  landingPage: string;
  mandatePodUrl: null | string;
  cardNumber: null | string;
  customerId: null | string;
  cardLimit: null | string;
  activationDate: null | string;
  expiryDate: null | string;
  crossSellOffers: null | string;
  emailOTPRequestId: null | string;
  crd_Pseudo_CN: null | string;
  cn_last_4_digit: null | string;
  channelId: string;
  requestDatetime: string;
  responseDatetime: string;
  status: string;
  message: string;
};

export const getCardDetails = async () => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<IOTPVRetryAPIResponse>({
      method: "POST",
      url: API_PATHS.otpVRetry,
      data: {
        mobileNo: mobileNo,
        cardType: "PL",
        cardSubType: "PL",
        tncVersionNumber: "testVersion-123456",
        tncFlag: "1",
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};
